'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import type { BreadcrumbItem } from '@/types/common';
import { breadcrumbsItem, breadcrumbsLink, breadcrumbsWrapper } from './styles';
import ChevronRightIcon from '/public/icons/chevron-right-pagination.svg';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
  const router = useRouter();

  const handleNavigation = (href: string) => {
    router.push(href, { scroll: true });
  };

  const checkIfIsExternalLink = (href: string) => {
    return href !== '#';
  };

  return (
    <nav aria-label="breadcrumb" className={clsx(breadcrumbsWrapper(), className)}>
      {items.map(({ label, href }, index) => {
        const isLast = items.length - 1 === index;
        return (
          <div className={breadcrumbsItem()} key={index}>
            {isLast ? (
              <button
                onClick={() => handleNavigation(href)}
                className={clsx(
                  checkIfIsExternalLink(href) ? 'cursor-pointer' : 'cursor-default',
                  breadcrumbsLink({ isLast })
                )}
              >
                {label}
              </button>
            ) : (
              <Link href={href} onClick={() => handleNavigation(href)} className={breadcrumbsLink({ isLast })}>
                {label}
              </Link>
            )}
            {!isLast && <ChevronRightIcon className="text-neutral-700 w-[19px] h-[19px]" />}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
